import ModeratorAddDisplay from "./ModeratorAddDisplay";
import LoadModeratorDisplay from "./LoadModeratorDisplay";
import LoadBroadcasterDisplay from "./LoadBroadcasterDisplay";
import BlueToggle from "../../../../common/BlueToggle";
import { useTranslation } from "react-i18next";
import "./moderatorListDisplay.css";

const ModeratorListDisplay = ({
    isButtonDisabled,
    handelKeyPressAddingModerator,
    newModeratorInput,
    setNewModeratorInput,
    inputDisplayMessage,
    listOfAllModerators,
    listOfAllBroadcasters,
    addModerator,
    updateModerator,
    deleteModerator,
    manualApprovalState,
    approvalToggleLogic,
    replaceModerator,
}) => {
    const { t } = useTranslation("moderatorPage");

    return (
        <div className="scrollableContainer">
            <div className="globalContentDiv">
                <div className="moderatorListDisplayContainer">
                    <div className="moderatorListDisplayManualApprovalToggle">
                        <BlueToggle
                            title={t("moderatorTitleManualApproval")}
                            onToggle={approvalToggleLogic}
                            state={manualApprovalState}
                        />
                    </div>

                    <ModeratorAddDisplay
                        handelKeyPressAddingModerator={
                            handelKeyPressAddingModerator
                        }
                        newModeratorInput={newModeratorInput}
                        setNewModeratorInput={setNewModeratorInput}
                        inputDisplayMessage={inputDisplayMessage}
                        isButtonDisabled={isButtonDisabled}
                        addModerator={addModerator}
                    />

                    <LoadModeratorDisplay
                        listOfAllModerators={listOfAllModerators}
                        isButtonDisabled={isButtonDisabled}
                        addModerator={addModerator}
                        updateModerator={updateModerator}
                        deleteModerator={deleteModerator}
                        manualApprovalState={manualApprovalState}
                        replaceModerator={replaceModerator}
                    />

                    <LoadBroadcasterDisplay
                        listOfAllBroadcasters={listOfAllBroadcasters}
                    />
                </div>
            </div>
        </div>
    );
};

export default ModeratorListDisplay;
